import * as React from 'react';

function Equestrian(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.727 3s.818.732.818 1.636c0 .904-.818 1.637-.818 1.637l-.05-.016.04-.043-.172.182C7.165 7.91 6.273 10.136 6.273 12a5.727 5.727 0 1011.454 0c0-1.866-.892-4.09-2.27-5.603l-.134-.14-.05.016s-.819-.733-.819-1.637S15.273 3 15.273 3H21v3.273h-2.057a9 9 0 11-13.886 0H3V3h5.727zM12 18.546a.818.818 0 100 1.636.818.818 0 000-1.636zm6.545-4.091a.818.818 0 100 1.635.818.818 0 000-1.636zm-13.09 0a.818.818 0 100 1.635.818.818 0 000-1.636zm13.09-6.546a.818.818 0 100 1.636.818.818 0 000-1.636zm-13.09 0a.818.818 0 100 1.636.818.818 0 000-1.636z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Equestrian;
